import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";
import { MicrositeHeading } from "pages/LayoutComponents/MicrositeHeading";
import styled, { css } from "styled-components";

export const HeroContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  overflow: hidden;
`;

export const TopGradient = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  max-height: 100px;
  z-index: 2;
`;

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  height: auto;
  max-height: 880px;
  max-width: 3840px;
  background-color: #151a29;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    max-height: 640px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    max-height: 560px;
  }
`;

export const BackgroundVideoWrapper = styled.div`
  width: 100%;
  position: relative;
  height: auto;
  max-height: 880px;
  max-width: 3840px;
  height: 880px;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    height: 640px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    height: 560px;
  }
`;

export const InvisibleButton = styled.button<{ $isRight?: boolean }>`
  background: transparent;
  border: none;
  display: none;
  height: 100%;
  left: 0;
  margin-top: 64px;
  outline: none;
  position: absolute;
  top: 0;
  width: 10%;
  z-index: 10;

  ${({ $isRight }) =>
    $isRight &&
    css`
      left: unset;
      right: 0;
    `}

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    display: block;
  }
`;

export const BackgroundVideo = styled.video<{ $isActive: boolean }>`
  position: absolute;
  inset: 0;
  height: 880px;
  width: 100%;
  object-fit: cover;
  transition: opacity 1s ease-out;
  opacity: 0;
  z-index: 0;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    height: 640px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    height: 560px;
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      transition: opacity 0.2s ease-in;
      transform: translateX(0);
      z-index: 2;
      opacity: 1;
    `}

  @keyframes showOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  @keyframes showIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const TabContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  z-index: 3;
  margin-bottom: 24px;
  opacity: 0;
  transform: translateY(15%);

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    flex-wrap: wrap;
  }
`;

export const ButtonWrapper = styled.div`
  box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.3);
  border-radius: 30px;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    display: none;
  }
`;

export const MainTitle = styled(MicrositeHeading)`
  h1 {
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const Tab = styled.button<{
  $isActive: boolean;
  $index?: number;
  $order: number;
}>`
  display: flex;
  align-items: flex-start;
  background: transparent;
  padding: 6px 18px;
  border-radius: 30px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: rgba(255, 255, 255, 0.1);
  outline: none;
  width: fit-content;
  overflow: hidden;
  backdrop-filter: blur(2px);
  order: ${({ $order }) => $order + 1};
  z-index: ${({ $order }) => 10 - $order};

  ${({ $isActive }) =>
    $isActive &&
    css`
      pointer-events: none;
      background: none;
      border: none;
      flex: 0 1 100%;
      backdrop-filter: none;
      justify-content: center;
      order: 0 !important;

      ${TabLabel} {
        font-size: 42px;
        line-height: 52px;
        font-weight: 900;
        text-align: center;

        @media ${BREAKPOINTS.TABLET_AND_DOWN} {
          font-size: 36px;
          line-height: 44px;
        }

        @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
          font-size: 28px;
          line-height: normal;
        }
      }
    `}
`;

export const TabLabel = styled.span`
  color: ${({ theme }) => theme.colors.white};
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  text-align: left;

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    font-size: 12px;
    line-height: 16px;
  }
`;

export const Title = styled.h1`
  color: #212427;
  font-size: 42px;
  font-weight: 900;
  line-height: 52px;
  margin: 0 0 16px;
  text-align: center;
  text-wrap: pretty;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    font-size: 32px;
    line-height: 40px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    font-size: 28px;
    line-height: normal;
  }
`;

export const Content = styled.div`
  width: 100%;
  position: absolute;
  top: 48px;
  z-index: 100;
  padding: 0 16px;

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const Gradient = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 120%;
  max-height: 420px;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(13, 18, 37, 0.9) 0%,
    rgba(21, 26, 41, 0.5) 60.28%,
    rgba(0, 0, 0, 0) 100%
  );
  filter: blur(27px);
  z-index: 2;
  transform: translate(-40px, -40px);

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    max-height: 320px;
  }
`;

export const IconContainer = styled.div`
  align-items: center;
  backdrop-filter: blur(5px);
  background: #c2c6cb;
  border-radius: 6px;
  display: flex;
  flex-shrink: 0;
  height: 32px;
  justify-content: center;
  overflow: hidden;
  position: relative;
  width: 32px;

  svg {
    color: white;
    z-index: 3;
  }
`;

export const StatusBarContainer = styled.button`
  display: none;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    outline: none;
    border-radius: 4px;
    display: flex;
    height: 3px;
    width: 100%;
    position: relative;
    width: 72px;
    overflow: hidden;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    width: 64px;
  }
`;

export const StyledStatusBar = styled.div<{
  $isActive: boolean;
  $playbackLimit: number;
}>`
  border-radius: 4px;
  height: 3px;
  position: absolute;
  top: 0;
  transform: translateX(-100%);
  width: 100%;

  ${({ $isActive, $playbackLimit }) =>
    $isActive &&
    css`
      animation: progress ${$playbackLimit}s linear;
      animation-fill-mode: forwards;
      background: ${({ theme }) => theme.colors.white};
    `}

  @keyframes progress {
    0% {
      transform: translateX(-100%);
    }

    100% {
      transform: translateX(0);
    }
  }
`;

export const Label = styled.span<{
  $shouldAnimate?: boolean;
  $playbackLimit?: number;
}>`
  color: transparent;
  background: linear-gradient(90deg, #212427 50%, #c2c6cb 50%);
  background-position: 100%;
  background-size: 200% 100%;
  background-clip: text;
  -webkit-background-clip: text;

  &:hover {
    color: #212427;
  }

  ${({ $shouldAnimate, $playbackLimit }) =>
    $shouldAnimate &&
    css`
      animation: textProgress ${$playbackLimit}s linear;
      animation-fill-mode: forwards;

      &:hover {
        color: transparent !important;
      }
    `}

  @keyframes textProgress {
    to {
      background-position: 0;
    }
  }
`;

export const SlideControlsWrapper = styled.div`
  position: absolute;
  bottom: 52px;
  left: 50%;
  z-index: 105;
  display: flex;
  gap: 8px;
  align-items: center;
  transform: translateX(-50%);
`;

export const SlideControl = styled.button<{ $isActive: boolean }>`
  width: 20px;
  height: 20px;
  background: transparent;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: none;

  ${({ $isActive }) =>
    $isActive &&
    css`
      border: 2px solid ${({ theme }) => theme.colors.white};
    `}
`;

export const Dot = styled.span`
  border-radius: 50%;
  background: #fff;
  height: 6px;
  flex-shrink: 0;
  width: 6px;
`;
